import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToDate'
})
export class NumberToDatePipe implements PipeTransform {

  transform(value: number): any {
    
    if (isNaN(value) == true) {
      return "";
    }

    let date = value.toString();

    let ano = date.substr(0,4);
    let mes = date.substr(4,2);
    let dia = date.substr(6,2);

    return `${dia}/${mes}/${ano}`;
  }

}
